var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobsFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6V4.5C7.5 3.11929 8.61929 2 10 2H14C15.3807 2 16.5 3.11929 16.5 4.5V6H22C23.1046 6 24 6.89543 24 8V9.25705L14.5 13.2477V13C14.5 12.4477 14.0523 12 13.5 12H10.5C9.94772 12 9.5 12.4477 9.5 13V13.2477L0 9.25705V8C0 6.89543 0.895431 6 2 6H7.5ZM8.5 4.5C8.5 3.67157 9.17157 3 10 3H14C14.8284 3 15.5 3.67157 15.5 4.5V6H8.5V4.5Z",
    fill: "#27323C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.3323L24 10.3417V20C24 21.1046 23.1046 22 22 22H2C0.89543 22 0 21.1046 0 20V10.3417L9.5 14.3323V15C9.5 15.5523 9.94771 16 10.5 16H13.5C14.0523 16 14.5 15.5523 14.5 15V14.3323Z",
    fill: "#27323C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13H10.5V15H13.5V13Z",
    fill: "#27323C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsFilled);
export default __webpack_public_path__ + "static/media/jobs-filled.4da614c70f4b503f6de852b504cabbe7.svg";
export { ForwardRef as ReactComponent };